import React, { useEffect, useRef } from 'react';
import styles from './ServiceCenterMap.module.css';
import mapboxgl from "!mapbox-gl"; // eslint-disable-line
import LocationIconActive from './../../../../assets/svg/location-active-icon.svg';

mapboxgl.accessToken = "pk.eyJ1IjoibWVocmFuNzlzYWRlZ2hpMiIsImEiOiJjbDNhNmY2ODcwMmluM2NsZWdlZzk0aWw4In0.xbk1STevQddVcoW_2_Vsqg";
// mapboxgl.baseApiUrl = "https://tile.snappmaps.ir";

const ServiceCenterMap = (props) => {

    const { lat, lng } = props;

    const mapContainer = useRef(null);
    const map = useRef(null);


    useEffect(() => {
        if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: "mapbox://styles/mapbox/streets-v11",
            center: [58.42943487697292, 23.586915844311307],
            zoom: 14,
        });

        if (map.current && (lat || lat === 0) && (lng || lng === 0)) {
            map.current.flyTo({
                center: [
                    (+lng).toFixed(4),
                    (+lat).toFixed(4),
                ],
                zoom: 14,
                essential: true, // this animation is considered essential with respect to prefers-reduced-motion
            });

            const el = document.createElement("div");
            const elImg = document.createElement("img");
            elImg.src = LocationIconActive 
            elImg.className = styles.LocationIcon;
            el.className = styles.CustomMarker;
            el.appendChild(elImg);

            new mapboxgl.Marker(el)
                .setLngLat([lng, lat])
                .addTo(map.current);

        }
    }, []) // eslint-disable-line


    return (
        <div className={styles.ServiceCenterMap}>
            <div ref={mapContainer} className={styles.MapContainer} />
        </div>
    )
}


export default ServiceCenterMap;